import { Component, OnInit, Input } from "@angular/core";
import { UserType, GlobalUser } from "../../models/user.model";
import { ProfileSettingsProvider } from "../../providers/profile-settings/profile-settings";
import { Api } from "../../providers/providers";

import {
  ToastController,
  AlertController,
  NavController,
  NavParams,
  App,
  ModalController,
  LoadingController
} from "ionic-angular";
import { CountryListProvider } from "../../providers/country-list/country-list";
import { LocationProvider } from "./../../providers/location/location";
import { User } from "./../../providers/user/user";
import { LoaderHelper } from "../../helpers/loader-helper";
import { ToastHelper } from "../../helpers/toastr-helper";
import { DocumentsProvider } from "../../providers/documents/documents";
import { take } from "rxjs/operators";

@Component({
  selector: "profile-info",
  templateUrl: "profile-info.html"
})
export class ProfileInfoComponent implements OnInit {
  @Input()
  isWelcome: boolean = false;
  user: UserType = new UserType();
  currentUser: any;
  profilePicture: any;
  keys: any;
  preselect: any;

  country_list: any = [];

  fileName: string;

  constructor(
    public app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private api: Api,
    private locationProvider: LocationProvider,
    private countryList: CountryListProvider,
    public modalCtrl: ModalController,
    private profileSettingsProvider: ProfileSettingsProvider,
    private userProvider: User,
    private documentsProvider: DocumentsProvider,
    private loadingCtrl: LoadingController
  ) {}

  ngOnInit() {
    this.getUserInfo();
    this.getCurrentUser();

    this.countryList.loadCountrys().subscribe(res => {
      this.keys = res;
      this.country_list = Object.keys(res).map(key => {
        return res[key];
      });
    });
  }

  getUserInfo(): void {
    this.profileSettingsProvider
      .getCurrentUser()
      .subscribe((response: UserType) => {
        this.user = response;
        this.fileName = this.hasCv(this.user);
        this.locationProvider.getLocation().subscribe(res => {
          for (var key in this.keys) {
            if (key === res.country && this.user.country === null) {
              this.user.country = this.keys[key] || "Aruba";
            }
          }
        });
      });
  }

  hasCv(user: UserType) {
    if (user.documentUuid) {
      const filename = this.cvFileName();
      return filename;
    }
    return null;
  }

  cvFileName() {
    return this.user.firstName + ' ' + this.user.lastName + ' CV';
  }

  updateUserInfo(user: UserType): void {
    this.profileSettingsProvider
      .updateUser(this.mapUserObject(user))
      .subscribe((response: UserType) => {
        if (this.isWelcome) {
          this.showWelcome();
        }
        let toast = this.toastCtrl.create({
          message: "Profile Updated",
          duration: 3000,
          position: "top"
        });

        toast.present();
      });

    // this.getUserInfo();
  }

  mapUserObject(user: GlobalUser) {
    const updateUser = new GlobalUser();
    updateUser.firstName = user.firstName;
    updateUser.lastName = user.lastName;
    updateUser.email = user.email;
    updateUser.about = user.about;
    updateUser.title = user.title;
    updateUser.company = user.company;
    updateUser.country = user.country;
    updateUser.countryCode = user.countryCode;
    updateUser.phone = user.phone;
    updateUser.lnPublicProfile = user.lnPublicProfile;
    updateUser.documentUuid = user.documentUuid || '';
    return updateUser;
  }

  getCurrentUser() {
    this.currentUser = this.userProvider.getCurrentUser();
  }

  showWelcome() {
    let confirm = this.alertCtrl.create({
      title: "Thanks for completing your profile",
      message:
        "For any further changes of information about yourself, visit this page - My Profile.",
      cssClass: "welcome-message",
      buttons: [
        {
          text: "Stay",
          handler: () => {
            console.log("Disagree clicked");
          }
        },
        {
          text: "Continue",
          handler: () => {
            this.app.getRootNav().push("HomePage");
          }
        }
      ]
    });
    confirm.present();
  }

  uploadPhoto() {
    let uploadModal = this.modalCtrl.create("ProfileImageUploadPage", {
      user: this.currentUser
    });
    uploadModal.onDidDismiss(data => {
      this.getUserInfo();
    });
    uploadModal.present();
  }

  editEmail() {
      let editEmail = this.modalCtrl.create("EditEmailPage", {
        user: this.currentUser
      });
      editEmail.onDidDismiss(data => {
        this.getUserInfo();
      });
      editEmail.present();
    }

  async documentChanged(event: any) {
    let file = event.target.files[0];
    // max size 1MB
    const sizeOk = file && file.size <= 1e+6;
    // type pdf
    const typeOk = file && file.type === "application/pdf";
    console.log("DOCUMENT: ", file);
    if (sizeOk && typeOk) {
      LoaderHelper.Show(this.loadingCtrl);
      let response = await this.documentsProvider.uploadCv(file);
      LoaderHelper.Hide();
      this.user.documentUuid= response.documentUuid;
      this.fileName = this.cvFileName();
      ToastHelper.Show(this.toastCtrl, "Document upload successful!", 3000);
    } else {
      ToastHelper.Show(
        this.toastCtrl,
        !sizeOk ? "Document to large!" : "Document must be PDF",
        3000
      );
    }
  }

  removeCv() {
    this.documentsProvider.deleteCv(this.user.documentUuid)
      .pipe(take(1))
      .subscribe(() => {
        this.user.documentUuid = null;
        this.fileName = null;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/profile-info/profile-info.ts